import React from "react";

import { MinimalInfoAlert } from "./MinimalInfoAlert";

export const PhoneNumberAlert: React.FC = () => (
    <MinimalInfoAlert filled={true}>
        This phone number will be used to send SMS for 2FA. VoIP numbers may not be able to receive the messages.
    </MinimalInfoAlert>
);
